export const paths = {
  // Sports routes
  sports: {
    home: (categoryId) => `/sports/${categoryId}`,
    groundListing: (categoryId) => `/sports/ground-listing/${categoryId}`,
    providerDetail: (providerId) => `/sports/provider-detail/${providerId}`,
    slotBook: "/sports/slot-book",
    bookingSummary: "/sports/booking-summary",
    serviceSelect: "/sports/service-select",
    bookingConfirm: "/sports/booking-confirm",
  },
  events: {
    list: (categoryId) => `/events/${categoryId}`,
    detail: (serviceId) => `/events/detail/${serviceId}`,
    addTicket: "/events/add-ticket",
    thanks: "/events/thanks",
    myTicket: (bookingId) => `/events/my-ticket/${bookingId}`,
    cancelBooking: "/events/cancel-booking",
    ticketDetail: (bookingId) => `/events/booking-detail/${bookingId}`,
  },
  rides: {
    home: "/rides",
    booking: "/rides/booking",
    summary: "/rides/summary",
    confirm: "/rides/confirm",
  },
  myBookings: {
    list: "/my-bookings",
    cancel: "/cancel-booking",
  },

  // Other routes
  notFound: "*",
};
